import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import api, { formatApiError } from './api';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/admin/login', { email, password });
      localStorage.setItem('nbl_admin_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-graphite px-5">
      <div className="w-full max-w-md border border-paper/10 bg-paper p-8 sm:p-10" data-testid="admin-login-card">
        <img src="/images/logo.png" alt="Nebraska Backyard Living" className="h-10 w-auto" />
        <h1 className="mt-8 font-serif text-3xl font-medium text-ink">Admin sign in</h1>
        <p className="mt-2 text-sm text-muted2">Access the site dashboard, leads, and live chat.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.2em] text-muted2">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" autoComplete="email" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.2em] text-muted2">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" autoComplete="current-password" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm font-medium text-red-700">{error}</p>}
          <button type="submit" data-testid="admin-login-button" disabled={loading} className="btn-primary w-full disabled:opacity-50">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4" /> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
